// export const API= "https://skytechbacknmp.skyangel.com.mx/api";

export const API =
//Local 
// "http://127.0.0.1:8000/api";
//Red Sky
// "http://192.168.0.114:8000/api"; 
//HO
// "http://192.168.100.53:8000/api";
// Producción
"https://skytechbacknmp.skyangel.com.mx/api";